import { CSSObject } from "@emotion/react";
import { typographyStyles } from "@newsela/angelou";

export const directionsLabel: CSSObject = {
  display: "block",
  fontWeight: "bold",
  marginTop: "10px",
};

export const directionsTextareaCssWrapper: CSSObject = {
  margin: "0 0 10px",
};

export const textareaCss: CSSObject = {
  width: "100%",
  display: "inline-block",
  padding: "5px",
  resize: "none",
  overflow: "hidden",
  height: "54px",
  ...typographyStyles.textMObj,
};

export const paragraphCss: CSSObject = {
  margin: 0,
  padding: "5px",
  height: "54px",
  overflow: "auto",
  ...typographyStyles.textMObj,
};
